import clsx from "clsx";
import useMobile from "src/hooks/useMobile";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import {
  MdOutlineFirstPage,
  MdOutlineLastPage,
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
} from "react-icons/md";
import { useTranslation } from "react-i18next";
import { memo } from "react";
import { ICON_SIZES } from "src/constants/icons";

interface ICardsPagination {
  hidePageCount?: boolean;
  canNext: boolean;
  next: () => void;
  prev: () => void;
  canPrev: boolean;
  totalPages: number;
  page: number;
  goTo: (page: number) => void;
  hideFirstPageButton?: boolean;
  hideLastPageButton?: boolean;
  pageSize: number;
  totalItems: number;
}

const CardsPagination: React.FC<ICardsPagination> = ({
  hidePageCount = false,
  canNext,
  next,
  prev,
  canPrev,
  totalPages,
  page,
  goTo,
  hideFirstPageButton = false,
  hideLastPageButton = false,
  totalItems = 0,
  pageSize = 0,
}) => {
  const { t } = useTranslation();

  const from = totalItems === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalItems);

  return (
    <div
      className={clsx([
        "flex",
        "flex-row",
        "gap-4",
        "w-full",
        "items-center",
        "justify-between",
      ])}
    >
      <div
        className={clsx([
          "text-xs",
          "flex-shrink-0",
          "flex",
          {
            hidden: hidePageCount,
          },
        ])}
      >
        {from}-{to} {t("misc:pagination.of")} {totalItems}
        {/* {page} {t("misc:pagination.of")} {totalPages} */}
      </div>
      <ButtonGroup
        buttons={[
          {
            icon: <MdOutlineFirstPage size={ICON_SIZES.SM} />,
            disabled: page === 1,
            onClick: () => goTo(1),
            tooltip: t("misc:pagination.first"),
            hide: hideFirstPageButton,
          },
          {
            onClick: () => prev(),
            icon: <MdOutlineNavigateBefore size={ICON_SIZES.SM} />,
            disabled: !canPrev,
            tooltip: t("misc:pagination.previous"),
          },
          {
            onClick: () => next(),
            icon: <MdOutlineNavigateNext size={ICON_SIZES.SM} />,
            disabled: !canNext,
            tooltip: t("misc:pagination.next"),
          },
          {
            icon: <MdOutlineLastPage size={ICON_SIZES.SM} />,
            disabled: page >= totalPages,
            onClick: () => goTo(totalPages),
            tooltip: t("misc:pagination.last"),
            hide: hideLastPageButton,
          },
        ]}
      />
    </div>
  );
};

export default memo(CardsPagination);
